import { render, staticRenderFns } from "./Endorsement.vue?vue&type=template&id=dd6a70b0&"
import script from "./Endorsement.vue?vue&type=script&lang=js&"
export * from "./Endorsement.vue?vue&type=script&lang=js&"
import style0 from "./Endorsement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports